import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { SharedModule } from '@shared';

import { FormlyConfig, FormlyModule } from '@ngx-formly/core';
import { FormlyFieldComboboxComponent } from './formly-template';
import { FormlyWrapperPanelComponent } from './formly-wrapper';
import { FormlyValidation } from './formly-validation';
import { AbstractControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { FormlyFieldFile } from '@shared/components/field-types/file-type/file-type.component';
import { FileValueAccessor } from '@shared/components/field-types/file-type/file-value-accessor';

export function passwordConfirmFieldMatchValidator(control: AbstractControl) {
  const {password, passwordConfirm} = control.value;

  // avoid displaying the message error when values are empty
  if (!passwordConfirm || !password) {
    return null;
  }

  if (passwordConfirm === password) {
    return null;
  }

  return {passwordConfirmFieldMatch: true};
}

/**
 * Formly global configuration
 */
const formlyModuleProviders = FormlyModule.forRoot({
  types: [
    {name: 'combobox', component: FormlyFieldComboboxComponent},
    { name: 'file', component: FormlyFieldFile, wrappers: ['form-field'] },
  ],
  wrappers: [{name: 'panel', component: FormlyWrapperPanelComponent}],
  validators: [
    {name: 'passwordConfirmFieldMatch', validation: passwordConfirmFieldMatchValidator},
  ],
  validationMessages: [],
}).providers as Provider[];

@NgModule({
  imports: [SharedModule],
  declarations: [FormlyFieldComboboxComponent, FormlyWrapperPanelComponent, FormlyFieldFile, FileValueAccessor],
  providers: [FormlyValidation],
})
export class FormlyConfigModule {
  constructor(formlyValidation: FormlyValidation, config: FormlyConfig, translation: TranslateService) {
    formlyValidation.init();

    translation.stream('validations.passwordConfirmFieldMatch').subscribe((message) => {
      config.addValidatorMessage('passwordConfirmFieldMatch', message);
    });
  }

  static forRoot(): ModuleWithProviders<FormlyConfigModule> {
    return {
      ngModule: FormlyConfigModule,
      providers: [formlyModuleProviders],
    };
  }
}
